export const environment = {
  production: true,
  mode: 'QA',
  authLoginUrl:
    'https://idm.staging.zsservices.com/Sanofi/IdentityManager/app/Web/login.aspx?ReturnUrl=',
  authLogoutUrl:
    'https://idm.staging.zsservices.com/Sanofi/IdentityManager/app/Web/logout.aspx',
  apiUrl: 'https://api.crt-sanofi.qa.zsservices.com/',
  errorHandling: {
    error_code_401: {
      Prod_url: 'https%3A%2F%2Fcrt-sanofi.zsservices.com',
      dev_url: 'https%3A%2F%2Fcrt-sanofi.qa.zsservices.com',
    },
    error_code_504: {
      Prod_url: 'https%3A%2F%2Fcrt-sanofi.zsservices.com',
      dev_url: 'https%3A%2F%2Fcrt-sanofi.qa.zsservices.com',
      message: 'Server is not responding. Please try again later.',
    },
    error_code_500: {
      message: 'Internal Server Error. Please try again later.',
    },
  },
};





